import { render } from "./X182.vue?vue&type=template&id=5a59d260"
import script from "./X182.vue?vue&type=script&lang=js"
export * from "./X182.vue?vue&type=script&lang=js"

import "./X182.vue?vue&type=style&index=0&id=5a59d260&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__